import { jsonProperty, Serializable } from "ts-serializable";
import Alternativa from "./Alternativa";

class Resposta extends Serializable{

    @jsonProperty(String, null)
    perguntaId: string | null = null;

    @jsonProperty(String, null)
    perguntaAnteriorId: string | null = null;

    @jsonProperty(String, null)
    valor: string | null = null;

    @jsonProperty([Alternativa], null)
    alternativas: Alternativa[] | null = null;
}  

export default Resposta;